module.exports = __webpack_public_path__ + "img/recommend.c2bda0c5.png";